(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accio-brand-story"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('[data-accio-story]');

    roots.forEach(function (root) {
      var lines = Array.prototype.slice.call(root.querySelectorAll('[data-accio-story-line]'));
      if (!lines.length) return;

      if (!('IntersectionObserver' in window)) {
        lines.forEach(function (line) {
          line.classList.add('is-visible');
        });
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '0px 0px -12% 0px', threshold: 0.15 }
      );

      lines.forEach(function (line) {
        observer.observe(line);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["accio-collection-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var toggles = document.querySelectorAll('[data-accio-facets-toggle]');

    toggles.forEach(function (toggle) {
      var panelId = toggle.getAttribute('aria-controls');
      var panel = panelId ? document.getElementById(panelId) : null;
      if (!panel) return;

      function setOpen(isOpen) {
        panel.classList.toggle('is-open', isOpen);
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        document.documentElement.classList.toggle('accio-facets-locked', isOpen);
      }

      toggle.addEventListener('click', function () {
        setOpen(!panel.classList.contains('is-open'));
      });

      panel.addEventListener('click', function (event) {
        var target = event.target;
        if (target && target.closest && target.closest('[data-accio-facets-close]')) {
          setOpen(false);
        }
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && panel.classList.contains('is-open')) {
          setOpen(false);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["accio-hero-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('[data-accio-hero]');

    roots.forEach(function (root) {
      if (root.getAttribute('data-accio-hero-ready') === 'true') return;
      root.setAttribute('data-accio-hero-ready', 'true');

      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-accio-hero-tab]'));
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-accio-hero-slide]'));
      if (!tabs.length || tabs.length !== slides.length) return;

      function activate(index, moveFocus) {
        tabs.forEach(function (tab, i) {
          var isActive = i === index;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          tab.setAttribute('tabindex', isActive ? '0' : '-1');
          if (isActive && moveFocus) tab.focus();
        });

        slides.forEach(function (slide, i) {
          var isActive = i === index;
          slide.classList.toggle('is-active', isActive);
          if (isActive) {
            slide.removeAttribute('hidden');
          } else {
            slide.setAttribute('hidden', '');
          }
        });
      }

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () {
          activate(i, false);
        });
      });

      root.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        var current = -1;
        tabs.forEach(function (tab, i) {
          if (tab.classList.contains('is-active')) current = i;
        });
        if (current < 0) return;
        var next = event.key === 'ArrowRight'
          ? (current + 1) % tabs.length
          : (current - 1 + tabs.length) % tabs.length;
        activate(next, true);
        event.preventDefault();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["accio-pdp-main"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-accio-gallery]').forEach(function (gallery) {
      if (gallery.getAttribute('data-accio-ready') === 'true') return;
      gallery.setAttribute('data-accio-ready', 'true');

      var main = gallery.querySelector('[data-accio-gallery-main]');
      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-accio-gallery-thumb]'));
      if (!main || !thumbs.length) return;

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var src = thumb.getAttribute('data-src');
          if (src) main.setAttribute('src', src);
          thumbs.forEach(function (other) {
            other.setAttribute('aria-current', other === thumb ? 'true' : 'false');
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
